import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-7151a9b3")

_pushScopeId("data-v-7151a9b3")
const _hoisted_1 = { class: "p-3 w-8/12" }
const _hoisted_2 = { class: "text-16px text-gray-lp-300 font-semibold" }
const _hoisted_3 = { class: "text-14px text-gray-lp-300" }
const _hoisted_4 = { class: "p-3 w-4/12" }
const _hoisted_5 = { class: "flex flex-row items-center justify-items-center" }
const _hoisted_6 = { class: "highlight-upselling flex gap-1" }
const _hoisted_7 = { class: "flex text-red-lp-100 gap-1 mt-2" }
const _hoisted_8 = { class: "text-14px" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_lp_button = _resolveComponent("lp-button")!
  const _component_card = _resolveComponent("card")!
  const _component_high_light_products = _resolveComponent("high-light-products")!
  const _component_less_products = _resolveComponent("less-products")!
  const _component_main_products = _resolveComponent("main-products")!
  const _component_more_products = _resolveComponent("more-products")!
  const _component_Icons = _resolveComponent("Icons")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    (_ctx.errorType === 'errorServer')
      ? (_openBlock(), _createBlock(_component_card, {
          key: 0,
          isShadow: false,
          class: "w-12/12 md:w-7/12 flex flex-row"
        }, {
          default: _withId(() => [
            _createVNode("div", _hoisted_1, [
              _createVNode("p", _hoisted_2, _toDisplayString(_ctx.errorCause), 1),
              _createVNode("p", _hoisted_3, _toDisplayString(_ctx.$t('Klik “Coba Lagi” untuk menampilkan ulang')), 1)
            ]),
            _createVNode("div", _hoisted_4, [
              _createVNode("div", _hoisted_5, [
                _createVNode(_component_lp_button, {
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.getPosterProduct(_ctx.shipmentId, _ctx.origin, _ctx.destination, _ctx.isVisiblePrice))),
                  title: "Coba Lagi",
                  iconLeft: "refresh-white",
                  textColor: "white",
                  color: "red-lp-100",
                  class: "ml-4"
                })
              ])
            ])
          ]),
          _: 1
        }))
      : (_openBlock(), _createBlock("div", {
          key: 1,
          class: ["wrapper-upselling", `${_ctx.isErrorRepair.productType ? 'border border-red-lp-100 p-0.5 rounded-xl' : ''}`]
        }, [
          _createVNode("div", _hoisted_6, [
            _withDirectives(_createVNode(_component_high_light_products, {
              firstRender: _ctx.firstRender,
              product: _ctx.productSameday,
              loading: _ctx.loading,
              onSetActive: _ctx.updateActiveHighLightProductSameday,
              isDisabled: _ctx.isDisabledProduct || _ctx.disableProductShipmentCod,
              version: _ctx.version,
              isEmbargo: _ctx.isEmbargo,
              hideKgs: _ctx.hideKgs
            }, null, 8, ["firstRender", "product", "loading", "onSetActive", "isDisabled", "version", "isEmbargo", "hideKgs"]), [
              [_vShow, _ctx.isSameday]
            ]),
            _createVNode(_component_high_light_products, {
              firstRender: _ctx.firstRender,
              product: _ctx.productHighlight,
              loading: _ctx.loading,
              onSetActive: _ctx.updateActiveHighLightProduct,
              isDisabled: _ctx.isDisabledProduct || _ctx.disableProductShipmentCod,
              version: _ctx.version,
              isEmbargo: _ctx.isEmbargo,
              hideKgs: _ctx.hideKgs
            }, null, 8, ["firstRender", "product", "loading", "onSetActive", "isDisabled", "version", "isEmbargo", "hideKgs"])
          ]),
          _createVNode("div", {
            class: `less-more-upselling ${_ctx.showButtonLessProduct ? '' : 'mt-5'}`
          }, [
            _withDirectives(_createVNode(_component_less_products, {
              firstRender: _ctx.firstRender,
              onUnExpand: _ctx.unExpandProduct,
              version: _ctx.version
            }, null, 8, ["firstRender", "onUnExpand", "version"]), [
              [_vShow, _ctx.showButtonLessProduct]
            ])
          ], 2),
          _createVNode("div", {
            class: _ctx.version === 'v2' ? 'another-content-upselling' : ''
          }, [
            _createVNode("div", {
              class: `grid grid-cols-1 ${_ctx.isOnePack || _ctx.isJumboPack ? 'md:grid-cols-7' : 'md:grid-cols-6'} ${_ctx.isOnePack || _ctx.isJumboPack ? 'lg:grid-cols-7' : 'lg:grid-cols-6' } gap-1`
            }, [
              _createVNode(_component_main_products, {
                firstRender: _ctx.firstRender,
                products: _ctx.products,
                loading: _ctx.loading,
                onSetActive: _ctx.updateProductActive,
                isDisabled: _ctx.isDisabledProduct || _ctx.disableProductShipmentCod,
                currentIndexProduct: _ctx.currentIndexProduct,
                isExpandProduct: _ctx.isExpandProduct,
                isOnePack: _ctx.isOnePack,
                version: _ctx.version,
                isEmbargo: _ctx.isEmbargo,
                hideKgs: _ctx.hideKgs
              }, null, 8, ["firstRender", "products", "loading", "onSetActive", "isDisabled", "currentIndexProduct", "isExpandProduct", "isOnePack", "version", "isEmbargo", "hideKgs"]),
              (_ctx.version === 'v1')
                ? _withDirectives((_openBlock(), _createBlock(_component_more_products, {
                    key: 0,
                    onExpand: _ctx.expandProduct,
                    loading: _ctx.loading,
                    firstRender: _ctx.firstRender,
                    isJumboPack: _ctx.isJumboPack
                  }, null, 8, ["onExpand", "loading", "firstRender", "isJumboPack"])), [
                    [_vShow, !_ctx.isExpandProduct && _ctx.isNonForeign]
                  ])
                : _createCommentVNode("", true)
            ], 2)
          ], 2)
        ], 2)),
    _withDirectives(_createVNode("div", _hoisted_7, [
      _createVNode(_component_Icons, {
        name: "warning-triangle",
        class: " w-4"
      }),
      _createVNode("p", _hoisted_8, _toDisplayString(_ctx.errorTariff.error ? _ctx.errorTariff.message : _ctx.isErrorRepair.productType ? _ctx.isErrorRepair.productTypeCaption : _ctx.errorCause), 1)
    ], 512), [
      [_vShow, _ctx.errorTariff.error || _ctx.errorType === 'errorData' || _ctx.isErrorRepair.productType]
    ])
  ], 64))
})